var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// anular components
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
// our own Components
import { NavbarComponent } from './../navbar/navbar.component';
import { NavbarResponsiveComponent } from './../navbar-responsive/navbar-responsive.component';
import { CreditsComponent, LogoComponent } from './credits.component';
import { EqualValidatorDirective } from './../settings/change-password/equal-validator.directive';
// 3rd party components
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { SelectModule } from 'ng2-select';
import { NguiMapModule } from '@ngui/map';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { AutoCompleteModule } from 'primeng/primeng';
import { InternationalPhoneModule } from 'ng4-intl-phone';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { FileUploadModule } from 'ng2-file-upload';
// import {FileUploadModule} from 'primeng/primeng';
import { PopoverModule } from 'ng2-popover';
import { LocalStorageModule } from 'angular-2-local-storage';
import { CalendarModule } from 'primeng/components/calendar/calendar';
import { SliderModule } from 'primeng/components/slider/slider';
// import { UiSwitchModule } from 'ngx-ui-switch';
// import {UiSwitchModule} from 'angular2-ui-switch';
// import {ConfirmationService} from 'primeng/components/common/api';
import { ConfirmDialogModule } from 'primeng/components/confirmdialog/confirmdialog';
import { RatingModule } from 'primeng/rating';
import { SidebarModule } from 'primeng/sidebar';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { NglModule } from 'ng-lightning';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ClipboardModule } from 'ngx-clipboard';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DialogModule } from 'primeng/components/dialog/dialog';
import { MomentModule } from 'angular2-moment';
import { AccordionModule } from 'primeng/components/accordion/accordion';
import { CheckboxModule } from 'primeng/components/checkbox/checkbox';
import { Ng4GeoautocompleteModule } from 'ng4-geoautocomplete';
import { ImageUploadModule } from 'angular2-image-upload';
import { DndModule } from 'ng2-dnd';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { ScrollPanelModule } from 'primeng/components/scrollpanel/scrollpanel';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
// import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import { ChartModule } from 'angular2-highcharts';
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService';
import { ClickOutsideModule } from 'ng-click-outside';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
// import {ToastModule} from 'ng2-toastr/ng2-toastr';// some proble with lazy loading
import { TabsModule } from 'ngx-bootstrap/tabs';
import 'froala-editor/js/froala_editor.pkgd.min.js';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { DynamicFormComponent } from '../settings/custom-fields/dynamic.component';
import { DynamicFormDeliComponent } from '../settings/dynamic-delivery.component';
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { AgmOverlays } from 'agm-overlays';
export function highchartsFactory() {
    var hc = require('highcharts');
    var dd = require('highcharts/modules/drilldown');
    dd(hc);
    return hc;
}
var SharedLazyModule = /** @class */ (function () {
    function SharedLazyModule() {
    }
    SharedLazyModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                RouterModule,
                ModalModule.forRoot(),
                BsDatepickerModule.forRoot(),
                TranslateModule,
                NguiMapModule.forRoot({ apiUrl: 'https://maps.google.com/maps/api/js?key=AIzaSyD_CxGAQe7cUjZ_Ps8f083VNBHJ8fy-pqs' }),
                AgmCoreModule.forRoot({
                    apiKey: '',
                    libraries: ['places']
                }),
                AgmJsMarkerClustererModule,
                AgmOverlays,
                CollapseModule.forRoot(),
                AutoCompleteModule,
                FormsModule,
                InternationalPhoneModule,
                PaginationModule.forRoot(),
                FileUploadModule,
                PopoverModule,
                LocalStorageModule.withConfig({
                    prefix: 'my-app',
                    storageType: 'localStorage'
                }),
                ReactiveFormsModule,
                CalendarModule,
                SliderModule,
                ConfirmDialogModule,
                RatingModule,
                SidebarModule,
                CarouselModule.forRoot(),
                NglModule.forRoot(),
                NgMultiSelectDropDownModule.forRoot(),
                ClipboardModule,
                SimpleNotificationsModule.forRoot(),
                OverlayPanelModule,
                DialogModule,
                MomentModule,
                AccordionModule,
                CheckboxModule,
                ClickOutsideModule,
                Ng4GeoautocompleteModule.forRoot(),
                ImageUploadModule.forRoot(),
                DndModule.forRoot(),
                AngularMultiSelectModule,
                ScrollPanelModule,
                BsDropdownModule.forRoot(),
                ChartModule,
                Ng2SearchPipeModule,
                FroalaEditorModule.forRoot(),
                FroalaViewModule.forRoot(),
                TabsModule.forRoot(),
            ],
            declarations: [
                NavbarComponent,
                NavbarResponsiveComponent,
                EqualValidatorDirective,
                CreditsComponent,
                LogoComponent,
                DynamicFormComponent,
                DynamicFormDeliComponent
            ],
            providers: [
                {
                    provide: HighchartsStatic,
                    useFactory: highchartsFactory
                },
                GoogleMapsAPIWrapper,
            ],
            exports: [
                CommonModule,
                RouterModule,
                BsDatepickerModule,
                ModalModule,
                TranslateModule,
                SelectModule,
                NguiMapModule,
                AgmCoreModule,
                AgmJsMarkerClustererModule,
                AgmOverlays,
                CollapseModule,
                AutoCompleteModule,
                FormsModule,
                InternationalPhoneModule,
                PaginationModule,
                FileUploadModule,
                PopoverModule,
                LocalStorageModule,
                CalendarModule,
                SliderModule,
                ConfirmDialogModule,
                RatingModule,
                SidebarModule,
                CarouselModule,
                NglModule,
                NgMultiSelectDropDownModule,
                ClipboardModule,
                SimpleNotificationsModule,
                OverlayPanelModule,
                DialogModule,
                MomentModule,
                AccordionModule,
                CheckboxModule,
                Ng4GeoautocompleteModule,
                ImageUploadModule,
                DndModule,
                AngularMultiSelectModule,
                ReactiveFormsModule,
                ScrollPanelModule,
                BsDropdownModule,
                ChartModule,
                ClickOutsideModule,
                Ng2SearchPipeModule,
                FroalaEditorModule,
                FroalaViewModule,
                TabsModule,
                NavbarComponent,
                NavbarResponsiveComponent,
                EqualValidatorDirective,
                CreditsComponent,
                LogoComponent,
                DynamicFormComponent,
                DynamicFormDeliComponent
            ]
        })
    ], SharedLazyModule);
    return SharedLazyModule;
}());
export { SharedLazyModule };



//////////////////
// WEBPACK FOOTER
// ./src/app/shared-module/shared-lazy.module.ts
// module id = ./src/app/shared-module/shared-lazy.module.ts
// module chunks = main